/** Default for newly created spaces */
export const DEFAULT_SPACE_COMETCHAT_CHAT_CONFIG = {
  appID: '263157cc941ff270',
  appRegion: 'EU',
};
